import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Logo } from '@/components/common';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-4 p-6 text-center">
      <Logo withText={false} />
      <h1 className="font-display text-3xl">{t('notFound.title')}</h1>
      <p className="text-ink-2">{t('notFound.body')}</p>
      <Button asChild variant="primary">
        <Link to="/">{t('notFound.home')}</Link>
      </Button>
    </main>
  );
}
